module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?240bb0bd1de09942c329e0624e9d116a";